
import { nextTick } from 'vue';
import {
    ASSIGN_USERS_TO_WORKFLOW_URL,
    UNASSIGN_USERS_FROM_WORKFLOW_URL,
    STEP_SIGNERS_URL
} from '@/utils/constants/constants.js';
import axios from 'axios';


export default{

    methods:{
        save_assignments() {
        if (!this.workflow_assignment_id || !this.entity_profile_id || !this.current_step) {
            this.show_error('Missing workflow assignment, entity profile or step information');
            return;
        }

        const assigned_users = this.assignable_user_rows.filter(
            user_row => user_row.is_assigned
        );

        if (assigned_users.length === 0) {
            this.clear_step_assignments();
            return;
        }

        // Otherwise → assign users
        const signers_payload = assigned_users.map((user_row, index) => ({
            signing_order: index + 1,
            user_id: user_row.id,
            email: user_row.email,
        }));

        const payload = {
            workflow_assignment_id: this.workflow_assignment_id,
            entity_profile_id: this.entity_profile_id,
            step_id: this.current_step.id,
            signers: signers_payload,
        };

        axios
            .post(ASSIGN_USERS_TO_WORKFLOW_URL, payload, {
            headers: this.headers,
            })
            .then(response => {
            const response_data = response.data || {};
            if (response_data.status === 'success') {
                this.show_success(
                response_data.message || 'Users assigned to workflow successfully'
                );
                this.load_step_signers();
            } else {
                this.show_error(
                response_data.message || 'Error assigning users to workflow'
                );
            }
            })
            .catch(error => {
            this.show_error(
                'Error assigning users to workflow: ' +
                (error.response?.data?.message || error.message)
            );
            });
        },


        
        clear_step_assignments() {
            if (!this.workflow_assignment_id || !this.entity_profile_id || !this.current_step) {
                this.show_error(
                'Missing workflow assignment, entity profile or step information',
                );
                return;
            }

            axios
                .post(
                UNASSIGN_USERS_FROM_WORKFLOW_URL,
                {
                    workflow_assignment_id: this.workflow_assignment_id,
                    entity_profile_id: this.entity_profile_id,
                    step_id: this.current_step.id,
                    // signer_ids and user_ids omitted -> clear all for this step
                },
                { headers: this.headers },
                )
                .then(response => {
                const response_data = response.data || {};

                if (response_data.status === 'success') {
                    this.show_success(
                    response_data.message ||
                        'Users unassigned from workflow step successfully',
                    );
                    this.assignable_user_rows = this.assignable_user_rows.map(
                    user_row => ({
                        ...user_row,
                        is_assigned: false,
                    }),
                    );
                    this.load_step_signers();
                } else {
                    this.show_error(
                    response_data.message ||
                        'Error unassigning users from workflow step',
                    );
                }
                })
                .catch(error => {
                this.show_error(
                    'Error unassigning users from workflow: ' +
                    (error.response?.data?.message || error.message),
                );
                });
        },

        async load_step_signers({ silent = false } = {}) {
            if (!this.workflow_assignment_id || !this.entity_profile_id) {
                return;
            }

            const response = await axios
                .get(STEP_SIGNERS_URL, {
                headers: this.headers,
                params: {
                    workflow_assignment_id: this.workflow_assignment_id,
                    entity_profile_id: this.entity_profile_id,
                },
                })
                .catch(error => {
                if (!silent) {
                    this.show_error(
                    'Error loading step signers: ' +
                        (error?.response?.data?.message || error.message),
                    );
                }
                return null;
                });

            // If the request failed, stop here
            if (!response) {
                return;
            }

            const response_data = response.data || {};
            if (response_data.status !== 'success') {
                if (!silent) {
                this.show_error(
                    response_data.message || 'Error loading step signers',
                );
                }
                return;
            }

            const payload = response_data.data || {};
            const api_steps = payload.steps || [];
            const signers_by_step_id = this.map_signers_by_step_id(api_steps);

            this.steps = this.steps.map(step_item => {
                const signers_meta = signers_by_step_id[step_item.id] || [];
                return {
                ...step_item,
                signers: signers_meta.map(signer => signer.name),
                signers_meta,
                };
            });

            this.local_steps = JSON.parse(JSON.stringify(this.steps));
            nextTick(this.measure_nodes);
        },

    }
}


